import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell from "../../../components/TruncatedCell";
import userManualService from "../../../services/userManual";
import { instanceToken } from "../../../utils/constant";

export default function UserManual() {
  const navigate = useNavigate();
  const [manuals, setManuals] = useState(null);

  useEffect(() => {
    const fetchManuals = async () => {
      try {
        const res = await userManualService.getAllUserManual(
          instanceToken.token
        );
        setManuals(res.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchManuals();
  }, []);

  const openDetail = (row) => navigate(`/user-manual/${row.id}`);

  const columns = [
    { id: "id", label: "ID", render: (row) => row.id },
    {
      id: "question_en",
      label: "Question (English)",
      render: (row) => <TruncatedCell value={row.question_en} />,
    },
    {
      id: "question_mm",
      label: "Question (Myanmar)",
      render: (row) => <TruncatedCell value={row.question_mm} myanmar />,
    },
    {
      id: "answers",
      label: "Number Of Answers",
      render: (row) => row.answers?.length ?? 0,
    },
  ];

  const rows = manuals || [];

  return (
    <DataListPage
      title="User Manual"
      rows={rows}
      columns={columns}
      count={rows.length}
      page={0}
      rowsPerPage={Math.max(rows.length, 10)}
      rowsPerPageOptions={[10, 25, 100]}
      onPageChange={() => {}}
      onRowsPerPageChange={() => {}}
      createButton={{
        label: "Create",
        onClick: () => navigate("/user-manual/create"),
      }}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      loading={!manuals}
    />
  );
}
